import { safeGet } from '../../../utils/safeGet'
import { get as _get, post as _post, fetchCustomMethod } from '../../../utils/fetcher'

export default {
  namespaced: true,

  state: {
    pagination: {
      perPage: 25,
      currentPage: 1,
      items: 0,
    },
    sortingValue: '',
    searchBarValue: '',
    scoringProfilesList: [],
  },

  mutations: {
    setPagination(state, data) {
      state.pagination = data
    },
    setSortingValue(state, data) {
      state.sortingValue = data
    },
    setSearchBarValue(state, data) {
      state.searchBarValue = data
    },
    setPaginationPerPage(state, data) {
      state.pagination.perPage = data
    },
    setPaginationCurrentPage(state, data) {
      state.pagination.currentPage = data
    },
    setScoringProfilesList(state, data) {
      state.scoringProfilesList = data
    },
  },

  actions: {
    loadScoringProfiles({ commit, getters, dispatch }) {
      dispatch('scoringProfilesCommon/setLoading', true, { root: true })
      const payload = {
        Sf: getters.getSearchBarValue,
        Page: getters.getPagination.currentPage,
        Size: getters.getPagination.perPage,
        Sort: getters.getSortingValue,
      }
      return new Promise((resolve, reject) => {
        _post('/api/scoringProfiles/list', payload)
          .then((data) => {
            commit('setPagination', {
              perPage: data.paging.pageSize,
              currentPage: data.paging.pageIndex,
              items: data.paging.totalItems,
            })
            commit('setScoringProfilesList', data.scoringProfiles)
            resolve()
          })
          .catch((err) => {
            reject(err)
          })
          .finally(() => {
            dispatch('scoringProfilesCommon/setLoading', false, { root: true })
          })
      })
    },

    deleteScoringProfile({ dispatch }, profileId) {
      return new Promise((resolve, reject) => {
        fetchCustomMethod(`/api/scoringProfiles/${profileId}`, 'DELETE', {})
          .then(() => {
            dispatch('loadScoringProfiles')
            resolve()
          })
          .catch((err) => reject(err))
      })
    },

    resetState({ state }) {
      state.pagination = {
        perPage: 25,
        currentPage: 1,
        items: 0,
      }
      state.sortingValue = ''
      state.searchBarValue = ''
      state.scoringProfilesList = []
    },
  },

  getters: {
    getPagination: (state) => {
      return safeGet(() => state.pagination, {
        perPage: 25,
        currentPage: 1,
        items: 0,
      })
    },
    getSortingValue: (state) => {
      return safeGet(() => state.sortingValue, '')
    },
    getSearchBarValue: (state) => {
      return safeGet(() => state.searchBarValue, '')
    },
    getScoringProfilesList: (state) => {
      return safeGet(() => state.scoringProfilesList, [])
    },
  },
}
